import { PageHeaderWrapper } from "@clipboard-health/ui-components";
import { PullToRefresh } from "@src/appV2/lib/PullToRefresh/PullToRefresh";
import { useSupportLinks } from "@src/appV2/support/hooks/useSupportLinks";
import { useZendeskArticle } from "@src/appV2/Zendesk/useZendeskArticle";

import { IconButton } from "../../../components/IconButton";
import { PageHeaderTopRow } from "../../../components/PageHeaderTopRow";
import { isScoreHealthy } from "../../utils/utils";

interface ClipboardScorePageHeaderProps {
  clipboardScore: number;
  onRefresh: () => Promise<void>;
}

export function ClipboardScorePageHeader(props: ClipboardScorePageHeaderProps) {
  const { clipboardScore, onRefresh } = props;
  const { openArticle } = useZendeskArticle();
  const { clipboardScoreSupportLink } = useSupportLinks();

  const handleInfoClick = async () => {
    await openArticle(clipboardScoreSupportLink);
  };

  return (
    <PageHeaderWrapper
      sx={{
        background: (theme) =>
          isScoreHealthy(clipboardScore)
            ? theme.palette.onboarding?.inProgress.gradient
            : theme.palette.onboarding?.error.gradient,
      }}
    >
      <PageHeaderTopRow
        rightAction={
          <IconButton iconType="info" size="medium" variant="outlined" onClick={handleInfoClick} />
        }
      />
      <PullToRefresh onRefresh={onRefresh} />
    </PageHeaderWrapper>
  );
}
